export const API_URL = "https://logixla.angel2h.com/api";
export const TOKEN_BEARER = "oimnat";
